import React from "react";
import DropDownComp1 from "./DropDownComp1";
import { RxCross2 } from "react-icons/rx";
import { useDrag, useDrop } from "react-dnd";
import { useDispatch } from "react-redux";
import { setLevel2Properties } from "../../../WorkbookSlice";

export default function DroppedData({
  handleDate,
  handleEdit,
  handleRemoveItem,
  data,
  viztype,
  reduxKey,
  dispatchCommonFilters,
  handleNumberFormat,
  handleGeogrophy,
  Sheetid,
  index,
  dispatchItemToredux,
  dispatchUpdateItem,
  dataSourceID,
  requiredArray,
}) {
  const dispatch = useDispatch();
  const moveItem = (fromIndex, toIndex) => {
    const updatedItems = [...requiredArray];
    const temp = updatedItems[fromIndex];
    updatedItems[fromIndex] = updatedItems[toIndex];
    updatedItems[toIndex] = temp;
    dispatch(
      setLevel2Properties({
        reduxKey,
        parentKey: "query",
        itemInArray: false,
        Sheetid,
        value: updatedItems,
      })
    );
  };

  const [{ isDragging }, drag] = useDrag({
    type: "Data",
    item: {
      _id: data._id,
      rename: data.rename,
      uuid: data.uuid,
      nanoId: data.nanoId,
      dataType: data.dataType,
      columnName: data.columnName,
      columnType: data.columnType,
      reduxKey,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: (item, monitor) => {
      const didDrop = monitor.didDrop();
      if (!didDrop) {
        console.log(`${item.columnName} removed`);
        handleRemoveItem(item); // this only triggers on full cancel
      }
    },
  });
  const [{ isOver }, drop] = useDrop({
    accept: "Data",
    hover: (item) => {
      const dataIndex = requiredArray.findIndex(
        (rItem) => rItem.nanoId === item.nanoId
      );
      if (dataIndex >= 0 && dataIndex !== index) {
        moveItem(dataIndex, index);
      }
    },
    drop: () => {
      return {}; // 👈 This marks the drop as successful!
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const name = (data) => {
    let name = data.rename;
    switch (data.dataType) {
      case "Number":
        if (
          ["MAX", "MIN", "AVG", "COUNT", "DISTINCT"].includes(
            data.measure?.value
          ) ||
          ["MAX", "MIN", "AVG", "COUNT", "DISTINCT"].includes(
            data.selectedMeasure
          )
        ) {
          name = data.measure
            ? `${data.measure.value}(${data.rename})`
            : `${data.selectedMeasure}(${data.rename})`;
        }
        break;
      case "Date":
        name = `${data.dateUnit}(${data.rename})`;
        break;
      case "String":
        name = data.rename;
        break;
      default:
        name = data.rename;
        break;
    }

    return name;
  };

  return (
    <div
      className={`font-light py-[2px] h-8 text-sm w-[94%] font-UberMoveTextRegular text-center  text-black rounded flex items-center justify-evenly mt-[0.15rem] ${
        isOver ? "bg-[#5ac189]" : "bg-custom-gray"
      }`}
      style={{ opacity: isDragging ? 0.5 : 1, cursor: "move" }}
      ref={(node) => drag(drop(node))}
    >
      <button className="w-5 flex items-center justify-center h-5 border-gray-300">
        <RxCross2
          className="text-black text-l cursor-pointer font-medium"
          onClick={() => handleRemoveItem(data)}
        />
      </button>
      <span className="w-[78%] border-x border-gray-500 truncate ">
        {name(data)}
      </span>
      {reduxKey && data && (
        <button className="flex items-center justify-center">
          <DropDownComp1
            {...{
              handleDate,
              handleEdit,
              handleRemoveItem,
              data,
              viztype,
              reduxKey,
              dispatchCommonFilters,
              handleNumberFormat,
              handleGeogrophy,
              Sheetid,
              index,
              dispatchItemToredux,
              dispatchUpdateItem,
              dataSourceID,
            }}
          />
        </button>
      )}
    </div>
  );
}
